import { render, staticRenderFns } from "./SfTextarea.vue?vue&type=template&id=21f280d6&functional=true&"
import script from "./SfTextarea.vue?vue&type=script&lang=js&"
export * from "./SfTextarea.vue?vue&type=script&lang=js&"
import style0 from "./SfTextarea.vue?vue&type=style&index=0&id=21f280d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports